import { useQuery } from 'react-query';

import { SIGNUP_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Country } from '../types';

export const getCountries = (): Promise<Country[]> => {
  const endPoint = SIGNUP_BACKEND_URL + 'countries';
  return axios
    .get(endPoint)
    .then((response: any) => {
      return response._embedded?.countries;
    })
    .catch((error) => {
      throw Error(`Critical error fetching countries (${endPoint}): ${error}`);
    });
};

type QueryFnType = typeof getCountries;

type UseCountriesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useCountries = ({ config = {} }: UseCountriesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getCountries(),
    ...config,
  });
};
